import FixaImage from "@coworker/apprestructured/src/shared/wrappers/FixaImage/FixaImage";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { joinClassNames } from "../utils";
import styles from "./media-card.module.css";

type MediaCardStatus = "Published" | "Unpublished";

const COLOR_BY_STATUS: Record<MediaCardStatus, string> = {
  Published: "#008a00",
  Unpublished: "rgb(214, 208, 198)",
};

type MediaCardImageProps = {
  imageUrl: string;
  imageAlt: string;
};

type MediaCardUtilities = {
  className?: string;
  dataTestId?: string;
};

export type MediaCardProps = MediaCardUtilities &
  MediaCardImageProps & {
    badgeLabel: string;
    title: string;
    fiscalYear: string;
    mediaType: string;
    status: MediaCardStatus;
  };

export const MediaCard = ({
  imageUrl,
  imageAlt,
  badgeLabel,
  title,
  fiscalYear,
  mediaType,
  status,
  className,
  dataTestId,
}: MediaCardProps) => (
  <article
    data-testid={dataTestId}
    className={joinClassNames(styles["card"], className)}
  >
    {badgeLabel && <div className={styles["badge"]}>{badgeLabel}</div>}

    <FixaImage
      className={joinClassNames(styles["mediaLayer"], styles["image"])}
      src={imageUrl}
      alt={imageAlt}
      fallback={!imageUrl}
    />
    <div
      className={joinClassNames(styles["mediaLayer"], styles["imageOverlay"])}
      aria-hidden="true"
    />

    <div className={styles["content"]}>
      <h2 className={joinClassNames(styles["field"], styles["title"])}>
        {title}
      </h2>
      <FixaText
        className={joinClassNames(styles["field"], styles["fiscalYear"])}
      >
        {fiscalYear}
      </FixaText>
      <FixaText
        className={joinClassNames(styles["field"], styles["mediaType"])}
      >
        {mediaType}
      </FixaText>
      <FixaText className={joinClassNames(styles["field"], styles["status"])}>
        <span
          className={styles["indicator"]}
          style={{ backgroundColor: COLOR_BY_STATUS[status] }}
          aria-hidden="true"
        />
        <span>{status}</span>
      </FixaText>
    </div>
  </article>
);
